import { render, staticRenderFns } from "./milkRecordingBetweenDates.vue?vue&type=template&id=3fa24dc3&scoped=true&"
import script from "./milkRecordingBetweenDates.vue?vue&type=script&lang=js&"
export * from "./milkRecordingBetweenDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa24dc3",
  null
  
)

export default component.exports